import axios from 'axios'
import {handleError} from '../handleError'
import {PassRule} from "../../object";

const state = {}
const getters = {}
const mutations = {}
const actions = {
  async getSelfInfo({dispatch}){
    let url = "/shiroApi/selfInfo"
    try {
      let res = null
      res = await axios.get(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 绑定微信公众号 */
  async bindWx ({dispatch}, code) {
    let url = '/shiroApi/wx/bind/' + code + '/tocommon/wxab508ecdccbc4e68'
    try {
      let res = null
      res = await axios.post(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 自动登录 */
  async autoLogin ({dispatch}, code) {
    let url = '/pipe/pass/jscodeAuth?jscode=' + code + '&appid=wxfd33224488b5cf00'
    try {
      let res = null
      res = await axios.post(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async autoLogin_wx ({dispatch}, code) {
    let url = '/shiroApi/wx/getWxSession/' + code + '/from/wxfd33224488b5cf00'
    try {
      let res = null
      res = await axios.get(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async bindUser ({dispatch}, {param, jsCode, phone,openId}) {
    let url = ""
    if(openId===undefined){
      url = '/pipe/pass/bindWechat?jscode=' + jsCode + '&appid=wxfd33224488b5cf00&phone=' + phone
    }else{
      url = '/pipe/pass/bindWechat?openId=' + openId + '&appid=wxfd33224488b5cf00&phone=' + phone
    }
    try {
      let res = axios.post(url, param)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async bindTempUser ({dispatch}, {param, jsCode, phone,openId}) {
    let url = '/pipe/pass/bindWechat?jscode=' + jsCode + '&appid=wxfd33224488b5cf00&phone=' + phone
    try {
      let res = axios.post(url, param)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getQrcode ({dispatch}) {
    let url = '/pipe/pass/getObjectQrcode'
    try {
      let res = await axios.get(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async checkData ({dispatch}, param) {
    let url = '/shiroApi/auth/thirdpart/validate?pipe=uestc-portal'
    try {
      let res = await axios.post(url, param)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async parseData ({dispatch}, {jscode, key, verifyKey, phone}) {
    let url = '/shiroApi/auth/thirdpart/regist?pipe=uestc-portal&jscode=' + jscode + '&key=' + key + '&verifyKey=' + verifyKey + '&phone=' + phone
    try {
      let res = await axios.post(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async bindVehicle ({dispatch, rootState}, {type, plate, DLImages, RLImages, OtherImages}) {
    let extend = {
      pic: [
        {name: '驾驶证', url1: DLImages.length!==0?(DLImages[0].url||''):''},
        {name: '行驶证', url2: RLImages.length!==0?(RLImages[0].url||''):''},
        {name: '其他证明', url3: OtherImages.length!==0?(OtherImages[0].url||''):''}
      ],
      msg: ''
    }
    let data = {
      'plateNumber': plate,
      'email': '',
      'phone': '',
      'groupId': type === 'org_ve' ? rootState.login.self.orgId : '',
      'checkType': type,
      'objectCheckInfo': JSON.stringify(extend)
    }

    return dispatch('getDataFromApi', {
      url: '/passApi/check/vehicle',
      method: 'post',
      data,
    }, {root: true})
  },
  async unBindWechat ({dispatch}) {
    let url = '/shiroApi/unbindWechat'
    try {
      let res = await axios.post(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getPassRule ({dispatch,rootState}, id) {
    let url = '/passObjectApi/pass/rule/object/' + id
    try {
      let res = await axios.post(url)
      if(res.data.status === 1){
        let controllers = rootState.parkingLot.personControllerList
        return {items: res.data.data.map(item => PassRule.fromAPI(item, controllers)),}
      }
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async checkPassLicense ({dispatch,rootState}, {id,plate}) {
    let url = '/passApi/check/group/object/info?groupId='+id+'&code='+plate
    try {
      let res = await axios.get(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async tempSelfSign({dispatch},controllerId){
    let url = '/passObjectApi/temp/sign?controllerId='+controllerId
    try {
      let res = await axios.post(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getTempSelfSignRecord({dispatch},{pagination}){
    let url = "/passObjectApi/temp/self/sign?page="+(pagination.page-1)+"&size="+pagination.rowsPerPage
    try {
      let res = await axios.get(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getTempSelfSignList({dispatch},{pagination,params}){
    let url = "/passObjectApi/temp/sign/list?page="+(pagination.page-1)+
    "&size="+pagination.rowsPerPage
    try {
      let res = await axios.post(url,params)
      if(res.data.status === 1){
        return {items:res.data.data.content,amount:res.data.data.totalElements}
      }else{
        return {items:[],amount:0}
      }
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
